var _g;
var _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
var SvgCalendarRecurring = function SvgCalendarRecurring(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 33.3 33",
    style: {
      enableBackground: "new 0 0 33.3 33"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M26.7,19L26.7,19l-0.4,0C26.5,19,26.6,19,26.7,19z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20.3,12.9h3.2v2.9h-3.2V12.9z M8.3,25.3H5.1v-2.9h3.2V25.3z M8.3,20.5H5.1v-2.9h3.2V20.5z M13.5,25.3h-3.2 v-2.9h3.2V25.3z M13.5,20.5h-3.2v-2.9h3.2V20.5z M13.5,15.8h-3.2v-2.9h3.2V15.8z M18.7,25.3h-3.2v-2.9h3.2V25.3z M18.7,20.5h-3.2 v-2.9h3.2V20.5z M18.7,15.8h-3.2v-2.9h3.2V15.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.3,27.1L19.3,27.1c0-0.4,0-0.7,0-1.1V27.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M21.5,6.1c1.1,0,2-0.9,2-2V2c0-1.1-0.9-2-2-2s-2,0.9-2,2v2.1C19.5,5.2,20.4,6.1,21.5,6.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M7.1,6.1c1.1,0,2-0.9,2-2V2c0-1.1-0.9-2-2-2s-2,0.9-2,2v2.1C5.1,5.2,6,6.1,7.1,6.1z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.3,
    y: 12.9,
    className: "st1",
    width: 3.2,
    height: 2.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.5,
    y: 12.9,
    className: "st1",
    width: 3.2,
    height: 2.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.3,
    y: 12.9,
    className: "st1",
    width: 3.2,
    height: 2.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.3,
    y: 17.6,
    className: "st1",
    width: 3.2,
    height: 2.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.5,
    y: 17.6,
    className: "st1",
    width: 3.2,
    height: 2.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.3,
    y: 22.4,
    className: "st1",
    width: 3.2,
    height: 2.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.1,
    y: 17.6,
    className: "st1",
    width: 3.2,
    height: 2.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.1,
    y: 22.4,
    className: "st1",
    width: 3.2,
    height: 2.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.5,
    y: 22.4,
    className: "st1",
    width: 3.2,
    height: 2.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M28.7,19.4V19V3.5h-4.1v1c0,1.7-1.4,3.1-3.1,3.1s-3.1-1.4-3.1-3.1v-1h-8.2v1c0,1.7-1.4,3.1-3.1,3.1 c-1.7,0-3-1.4-3-3.1v-1L0,3.4v25.7h2.1h17.2h0.7c1.1,2.3,3.4,3.8,6.1,3.9h0.3c3.7-0.1,6.7-3.1,6.8-6.8v-0.3 C33.2,22.9,31.3,20.4,28.7,19.4z M19.3,27.1H2.1V10.7h24.6V19v0c-0.1,0-0.2,0-0.4,0c-1,0-2,0.2-2.8,0.6V19v-1.4h-3.2V19v1.5H22 c-0.7,0.5-1.2,1.2-1.7,1.9h0v0c-0.6,1-1,2.3-1,3.6C19.3,26.4,19.4,26.7,19.3,27.1L19.3,27.1z M26.4,31.4v-1.5 c-0.9,0-1.7-0.3-2.4-0.8c-0.6-0.5-1.1-1.2-1.4-2c-0.1-0.4-0.2-0.7-0.2-1.1c0-0.2,0-0.5,0.1-0.7c0.1-0.5,0.3-1,0.5-1.4l0.5,0.5 l0.2,0.2c-0.1,0.2-0.2,0.4-0.2,0.6c0,0,0,0,0,0.1c-0.1,0.2-0.1,0.4-0.1,0.7c0,0.4,0.1,0.8,0.2,1.1c0.4,1.1,1.5,1.9,2.8,1.9v-1.5 l1.6,1.6l0.3,0.3L26.4,31.4z M29.8,28.1L29,27.4c0.2-0.4,0.3-0.9,0.3-1.4c0-0.7-0.3-1.3-0.7-1.9c-0.5-0.6-1.2-1-2-1.1 c-0.1,0-0.2,0-0.3,0v1.5l-2-2l2-2V22c0.1,0,0.2,0,0.3,0c0.7,0.1,1.4,0.3,2,0.7c1,0.7,1.7,1.9,1.7,3.2 C30.4,26.8,30.1,27.5,29.8,28.1z"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCalendarRecurring, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/calendar-recurring.d318a1a7.svg";
export { ForwardRef as ReactComponent };